import { Heading, Stack, Text } from '@chakra-ui/react';
import useWorkshopQuery from 'hooks/useWorkshopQuery';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ISubscriptionAddon } from '../../api/types';
import { DataTable } from '../../components/Table/DataTable';

const AddonsDetailsCard = (props: { workshopId: number }) => {
  const { t } = useTranslation();
  // @ts-ignore
  const { workshopId } = props;
  const workshopQuery = useWorkshopQuery(workshopId);
  const allAddonObjects: ISubscriptionAddon[] = workshopQuery?.data?.subscription?.active_addons || [];
  const allAddonsTransformed = Object.keys(allAddonObjects)?.map((key: string) => ({
    name: key,
    // @ts-ignore
    ...allAddonObjects[key],
  }));

  const columns = useMemo(
    () => [
      {
        Header: t('chargebee:addons.data_table.name'),
        Accessor: 'name',
        // @ts-ignore
        Cell: (cellProps) => {
          const { row } = cellProps;
          const addonName = row?.original.name;
          return <Text>{addonName ? t(`chargebee:addons.${addonName}.name`) : '-'}</Text>;
        },
      },
      {
        Header: t('chargebee:addons.data_table.status'),
        Accessor: 'trial',
        // @ts-ignore
        Cell: (cellProps) => {
          const { row } = cellProps;
          const addonIsOnTrial = row?.original.trial;
          return <Text>{addonIsOnTrial ? t('chargebee:addons.data_table.trial') : t('chargebee:addons.data_table.activated')}</Text>;
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allAddonsTransformed],
  );

  return (
    <Stack direction={['column', 'row']} w={'100%'}>
      <Stack direction="column" w="full">
        <Heading as="h4" size="xxs" pt={10}>
          {t('chargebee:addons.active_addons')}
        </Heading>
        <DataTable
          hasFilters={false}
          data-test-id="active-addons-table"
          data={allAddonsTransformed || []}
          columns={columns}
          loading={workshopQuery.isLoading}
          isMoreThenOnePage={false}
        />
      </Stack>
    </Stack>
  );
};

export default AddonsDetailsCard;
